import LFPluginRemoveDots from "./plugins/remove-dots/remove-dots";
import LFPluginRemoveSpaces from "./plugins/remove-spaces/remove-spaces";
import LFPluginUppercase from "./plugins/uppercase/uppercase";

export const LiveFormatter = (() => {
  const _config = {
    dataAttribute: "data-live-format",
    foundInputs: [],
  };

  const init = () => {
    _findInputs();
    _bindEvents();
  };

  /* Finds all inputs that have the required data attribute which specifies the custom formatters for this input */
  const _findInputs = () => {
    document.querySelectorAll(`[${_config.dataAttribute}]`).forEach((input) => {
      _config.foundInputs.push({
        el: input,
        formatters: input.dataset.liveFormat.split(",").map((item) => {
          return item.trim();
        }),
      });
    });
  };

  /* Finds the correct formatter code, and binds the correct event and function to the current input */
  const _bindEvents = () => {
    // plugins object is used to dynamically access the plugins
    const plugins = {
      LFPluginUppercase,
      LFPluginRemoveSpaces,
      LFPluginRemoveDots,
    };
    _config.foundInputs.forEach((input) => {
      input.formatters.forEach((formatter) => {
        // build the correct plugin name
        const plugin = plugins[_getFormatterClassName(formatter)];
        if (!plugin) {
          return;
        }

        // get the correct event
        const event = _getEvent(input.el, plugin);

        // add plugin code to the correct event
        input.el.addEventListener(event, (e) => {
          plugin.run(e.target);

          // Add callback to notify when a live format plugin was ran (used in validation for example)
          e.target.dispatchEvent(new Event("postLiveFormat"));
        });
      });
    });
  };

  const _getEvent = (el, plugin) => {
    if (el.dataset.liveFormatEvent) {
      return el.dataset.liveFormatEvent;
    }

    return plugin.event;
  };

  const _getFormatterClassName = (name) => {
    return `LFPlugin${name}`;
  };

  return {
    init: init,
  };
})();
